import { createApp } from 'vue'
import App from './App.vue'
import VueAxios from "vue-axios"
import http from "./http"
import store from "./store"
import router from "@/router"
import Number from "@coders-tm/vue-number-format"
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

//const shadowMountPoint = document.createElement("div")
//const appMountPoint = document.createElement("div")
const container = document.getElementById("pamaculator-app")
const extData = container.dataset
const agencyId = extData && extData.id ? extData.id : null
const cta = {
    text: extData.ctaText || null,
    url: extData.ctaUrl || null,
    target: extData.ctaTarget || '_blank'
}

store.commit('agencyId', agencyId)
store.commit('cta', cta)

const stringIsTruthy = (value) => {
    return value === 'true' || value === '1'
}

if(process.env.VUE_APP_MUST_LOGIN){
    store.commit('mustLogin', true)
}

if(process.env.VUE_APP_HIDE_TYPE){
    store.commit('hideType', true)
}

if(extData.mustLogin){
    store.commit('mustLogin', stringIsTruthy(extData.mustLogin))
}
if(extData.hideYear){
    store.commit('hideYear', stringIsTruthy(extData.hideYear))
}
if(extData.hideType){
    store.commit('hideType', stringIsTruthy(extData.hideType))
}
if(extData.hideAge){
    store.commit('hideAge', stringIsTruthy(extData.hideAge))
}
if(extData.defaultYear){
    store.commit('defaultYear', extData.defaultYear)
}
if(extData.defaultAge){
    store.commit('defaultAge', extData.defaultAge)
}
if(extData.carCost){
    store.commit('carCost', extData.carCost)
}
if(extData.showOnlyResults){
    store.commit('showOnlyResults', stringIsTruthy(extData.showOnlyResults))
}
if(extData.defaultPresets){
    store.commit('defaultPresets', extData.defaultPresets)
}
if(extData.titleText){
    store.commit('titleText', extData.titleText)
}
if(extData.bulletLoanLabel){
    store.commit('bulletLoanLabel', extData.bulletLoanLabel)
}
if(extData.monthsLabel){
    store.commit('monthsLabel', extData.monthsLabel)
}
if(extData.imprestLabel){
    store.commit('imprestLabel', extData.imprestLabel)
}
if(extData.monthlyPaymentLabel){
    store.commit('monthlyPaymentLabel', extData.monthlyPaymentLabel)
}
if(extData.carType){
    store.commit('carType', extData.carType)
}
if(extData.onlyCarType){
    store.commit('onlyCarType', stringIsTruthy(extData.onlyCarType))
}
if(extData.imprest){
    store.commit('defaultImprest', extData.imprest)
}
if(extData.bulletLoan){
    store.commit('defaultBulletLoan', extData.bulletLoan)
}
if(extData.leasingCalculatorEnabled){
    store.commit('leasingCalculatorEnabled', stringIsTruthy(extData.leasingCalculatorEnabled))
}
if(extData.lightTheme){
    store.commit('lightTheme', stringIsTruthy(extData.lightTheme))
}
if(extData.imageUrl){
    store.commit('imageUrl', extData.imageUrl)
}
if(extData.env){
    if(extData.env === 'staging'){
        http.defaults.baseURL = process.env.VUE_APP_STAGING_BASE_URL+process.env.VUE_APP_API_PATH;
    }
}

const app = createApp(App)
    .use(store)
    .use(router)
    .use(VueAxios, http)
    .use(Number, {
        separator: ',',
        precision: 2
    })
    .use(VueLoading)

/*const styleLinks = document.querySelectorAll('link')
if(styleLinks && styleLinks.length > 0){
    styleLinks.forEach(style => {
        if(style.id && style.id.includes('pamaculator')){
            shadowMountPoint.appendChild(style.cloneNode(true))
        }
    })
}*/

/*const styles = document.querySelectorAll('head style')
if(styles && styles.length > 0){
    styles.forEach(style => {
        if(style.innerHTML.includes('.shadow-calculator')){
            shadowMountPoint.appendChild(style.cloneNode(true))
        }else if(style.innerHTML.includes('.slider-connect')) {
            shadowMountPoint.appendChild(style.cloneNode(true))
        }else if(style.innerHTML.includes('.login-form')) {
            shadowMountPoint.appendChild(style.cloneNode(true))
        }else if(style.innerHTML.includes('.pama-app')) {
            shadowMountPoint.appendChild(style.cloneNode(true))
        }else if(style.innerHTML.includes('.vld-overlay')) {
            shadowMountPoint.appendChild(style.cloneNode(true))
        }else if(style.innerHTML.includes('.leasing-calculator')) {
            shadowMountPoint.appendChild(style.cloneNode(true))
        } else if (style.innerHTML.includes(".agents-area")) {
            // I have set it for all the agents area pages
            shadowMountPoint.appendChild(style.cloneNode(true));
        }
    })
}*/

//container
//.attachShadow({ mode: "open" })
//.appendChild(shadowMountPoint)
//shadowMountPoint.appendChild(appMountPoint)
app.mount(container)
